import { WebsiteHeaderPhotoSchema_Center_v1_1_1 } from '@apps/guest/websiteHeader';

export const CENTER_v1_1_1: WebsiteHeaderPhotoSchema_Center_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/center-v1_1_1.json',
  presentationLayout: 'center',
  photos: [],
};
